import React from "react";
import { Icon } from "antd";
import { Storage } from "aws-amplify";

class OrderFile extends React.Component {
  loadInterval = false;
  state = {
    fileLink: ""
  };

  componentDidMount() {
    const { file } = this.props;
    this.loadInterval = setInterval(this.getFile(file), 500);
  }

  componentWillUnmount() {
    this.loadInterval && clearInterval(this.loadInterval);
    this.loadInterval = false;
  }

  getFile = file => {
    Storage.get(file.key, {
      level: "private",
      bucket: file.bucket,
      region: file.region,
      identityId: file.identityId
    }).then(result => {
      this.loadInterval &&
        this.setState(() => {
          return { fileLink: result, loading: false };
        });
    });
  };

  render() {
    const { file } = this.props;
    return (
      <div className="messenger-file file-message order-response">
        <div className="messenger-file__icon">
          <Icon type="file-text" />
        </div>
        <div className="messenger-file__content">
          <div className="messenger-file__content-top">
            <div className="file-type">{file.key.split(".").pop()}</div>
            <a href={this.state.fileLink} target="_blank">
              <Icon
                type="download"
                style={{
                  fontSize: 14,
                  cursor: "pointer"
                }}
              />
            </a>
          </div>

          <div className="messenger-file__content-name">
            {file.key.split("/").pop()}
          </div>
        </div>
      </div>
    );
  }
}

export default OrderFile;



// WEBPACK FOOTER //
// ./src/Components/Orders/OrderFile.js